<template>
    <div :class="['navbar-area', {'is-sticky': isSticky}]">
        <div class="main-navbar">
            <div class="container">
                <nav class="navbar navbar-expand-md navbar-light">
                    <div class="logo">
                        <router-link to="/">
                            <h2>Smile Make Over</h2>
                            <!-- <img src="../../assets/images/logo.png" alt="logo"> -->
                        </router-link>
                    </div>

                    <div 
                        class="navbar-toggler"
                        @click="active = !active" :aria-pressed="active ? 'true' : 'false'"
                        v-bind:class="{ 'active': button_active_state }"
                        v-on:click="button_active_state = !button_active_state"
                    >
                        <span class="icon-bar top-bar"></span>
                        <span class="icon-bar middle-bar"></span>
                        <span class="icon-bar bottom-bar"></span>
                    </div>

                    <div class="collapse navbar-collapse" :class="{ show: active }" is-nav>
                        <ul class="navbar-nav">
                            <li class="nav-item">
                                <router-link to="/" class="nav-link">
                                    {{ $t('nav_home_main') }}
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/our-clinic" class="nav-link" exact>
                                    {{ $t('nav_clinic') }}
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/our-team" class="nav-link">
                                    {{ $t('nav_team') }}
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/services" class="nav-link">
                                    {{ $t('nav_services') }}
                                </router-link>
                            </li>

                            

                            <li class="nav-item">
                                <router-link to="/gallery" class="nav-link">
                                    {{ $t('nav_before_after') }}
                                </router-link>
                            </li>

                            <li class="nav-item">
                                <router-link to="/dental-tourism" class="nav-link">
                                    {{ $t('nav_dental_tourism') }}
                                </router-link>
                            </li>

                            <li class="nav-item">
                                <router-link to="/contact-us" class="nav-link">
                                    {{ $t('nav_contact') }}
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/pricing" class="nav-link">
                                    {{ $t('nav_prices') }}
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/blog" class="nav-link">
                                    {{ $t('nav_blog') }}
                                </router-link>
                            </li>

                            <div class="language-container">
                                <div class="nav-link">
                                    <div class="language_picker mt-2">
                                        <img class="mr-2" src="../../assets/nav-flags/united-kingdom.png" width='24' height='16' alt="Language selection icon" @click="changeLanguage('en')"/>
                                    </div>
                                </div>
<!--
                                <div class="nav-link">
                                    <div class="language_picker mt-2">
                                        <img class="mr-2" src="../../assets/nav-flags/france.png" width='24' height='16' alt="Language selection icon" @click="changeLanguage('fr')"/>
                                    </div>
                                </div>

                                <div class="nav-link">
                                    <div class="language_picker mt-2">
                                        <img class="mr-2" src="../../assets/nav-flags/germany.png" width='24' height='16' alt="Language selection icon" @click="changeLanguage('de')"/>
                                    </div>
                                </div>-->

                                <div class="nav-link">
                                    <div class="language_picker mt-2">
                                        <img class="mr-2" src="../../assets/nav-flags/greece.png" width='24' height='16' alt="Language selection icon" @click="changeLanguage('gr')"/>
                                    </div>
                                </div>
                            </div>
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import router from '../../router'; 

export default {
    name: 'NavBarSmallScreen',
    components: {
    },
    data() {
        return {
            isSticky: false,
            active: false,
            openDropdown: null,
            button_active_state: false,
            showPreloader: false ,

            dropdowns: {
                cosmetic: false,
                veneers: false
        }
        };
    },
    mounted() {
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        if (selectedLanguage) {
            this.$i18n.locale = selectedLanguage;
        }
        const that = this;
        window.addEventListener('scroll', () => {
            let scrollPos = window.scrollY;
            if (scrollPos >= 100) {
                that.isSticky = true;
            } else {
                that.isSticky = false;
            }
        });

        router.beforeEach((to, from, next) => {
            if (this.active) {
                this.active = false;
            }
            next();
        });
    },
    methods: {
        changeLanguage(lang) {
            this.showPreloader = true;
            window.location.reload();

            this.$i18n.locale = lang;
            localStorage.setItem('selectedLanguage', lang);

            setTimeout(() => {
                this.showPreloader = false;
            }, 2500); 
        },
        
        

        toggleDropdown(name) {
            this.dropdowns[name] = !this.dropdowns[name];
        },
        isDropdownOpen(name) {
            return this.dropdowns[name];
        }
    }
};
</script>

